module.exports = __webpack_public_path__ + "img/sankaku_85_red.55595214.png";